import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const state = {
  company: null,
}

const namespaced = true

export const companies = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
